import type { InspirationArticleRightHandBlockDTO } from 'autogen/swagger/all';
import Brand from './components/Brand';
import Share from './components/Share';
import AuthorInfo from '../AuthorInfo/AuthorInfo';

export type InspirationArticleRightHandPlaceholderProps = {
    model: InspirationArticleRightHandBlockDTO;
};

export default function InspirationArticleRightHandPlaceholder(props: InspirationArticleRightHandPlaceholderProps) {
    const { model } = props;

    return (
        <div>
            {model.brand && <Brand {...model.brand} />}
            {model.facebookShareLinkAction && <Share facebookShareUrl={model.facebookShareLinkAction} />}
            <AuthorInfo {...model.author} />
        </div>
    );
}
